module.exports = __webpack_public_path__ + "img/snapinsta-blog.0b9c6e5a.webp";